import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24">
        <section className="py-20 bg-gradient-to-br from-primary-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
              プロジェクト概要
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl">
              心不全の早期発見と慢性管理に関する地域連携プロジェクト
            </p>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
              <div className="lg:col-span-3">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">プロジェクトの目的</h2>
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6">
                    本プロジェクトは、国家公務員共済組合連合会虎の門病院循環器センター及び心臓リハビリテーションチームが中心となり、心不全の早期発見と適切な慢性管理を通じて、患者さんの生活の質（QOL）の向上と医療費の適正化を目指しています。本プロジェクトは、ファイザー財団の教育助成により行われています。
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    心不全は、高齢化社会において増加の一途をたどる重要な疾患です。地域のかかりつけ医療機関と専門医療機関が連携し、患者さんを中心とした包括的なケア体制を構築することで、心不全の進行を防ぎ、急性増悪による入院を減少させることができます。
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    地域の医療機関の先生方と協力し、患者さん向けの啓発活動を通じて、心不全に関する正しい知識の普及にも取り組んでいます。
                  </p>
                </div>

                <div className="mt-12">
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">プロジェクトの特徴</h2>
                  <div className="space-y-6">
                    <div className="flex gap-4">
                      <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0">
                        <i className="ri-hospital-line text-2xl text-primary-600"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">地域医療連携</h3>
                        <p className="text-gray-600 leading-relaxed text-sm">
                          地域医療連携で早期心不全発見から、慢性期の心不全加療のサポートまでシームレスな医療の提供を目指します。
                        </p>
                      </div>
                    </div>

                    <div className="flex gap-4">
                      <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0">
                        <i className="ri-stethoscope-line text-2xl text-primary-600"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">早期発見システム</h3>
                        <p className="text-gray-600 leading-relaxed text-sm mb-3">
                          心不全症状、BNP/NT-proBNPの値から心不全を疑う場合は、当院をはじめとする急性期病院での専門医のご紹介をおすすめしております。港区では「みなと心不全協議会」が中心となり、住民健診での心不全リスク評価（心不全健診）や、循環器専門施設へのスムーズな紹介体制を整え、早期発見・介入を推進しています。
                        </p>
                        <div className="bg-primary-50 p-4 rounded-lg mt-3">
                          <p className="text-xs font-semibold text-gray-900 mb-2">※循環器疾患を専門に見ている地域医療機関の先生方へ</p>
                          <p className="text-xs text-gray-700 leading-relaxed">
                            当院では、心不全精査のため、経胸壁心エコー検査、経食道心エコー検査、運動（薬剤）負荷心エコー検査、各種心筋シンチ検査、MRI検査、心肺運動負荷試験（CPX）を行っております。検査のご要望などございましたら、ご相談いただければ幸いに存じます。
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="flex gap-4">
                      <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0">
                        <i className="ri-heart-pulse-line text-2xl text-primary-600"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">包括的な疾病管理プログラムとしての慢性管理へ</h3>
                        <p className="text-gray-600 leading-relaxed text-sm">
                          心不全は、再発予防、予後改善のためリハビリのような運動指導だけでなく包括的な疾病管理プログラムが必要になります。そのためには、定期的な栄養指導、運動指導、リスクの管理を継続することが重要となります。基本的には、慢性管理はかかりつけ医療機関の先生にご紹介することになりますが、栄養指導や運動指導が困難な場合などは、地域で支えていく必要があると考えております。また、入院加療後の経過なども含めて、日本心不全学会が作成している心不全手帳や、ジャパンハートクラブが作成している心臓リハビリテーション手帳、各団体が作成している高血圧手帳などを有効に活用し、連携に役立てていく方針です。
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2">
                <div className="sticky top-32 space-y-6">
                  <div className="bg-gradient-to-br from-primary-500 to-primary-600 p-8 rounded-3xl text-white">
                    <h3 className="text-2xl font-bold mb-6">虎の門病院の特徴</h3>
                    <div className="space-y-5">
                      <div className="border-b border-white/20 pb-5">
                        <div className="text-lg font-bold mb-2">①急性期総合病院の強み</div>
                        <div className="text-primary-100 text-sm leading-relaxed">他科との連携した治療が可能です</div>
                      </div>
                      <div className="border-b border-white/20 pb-5">
                        <div className="text-lg font-bold mb-2">②多職種連携</div>
                        <div className="text-primary-100 text-sm leading-relaxed">医師、看護師、理学療法士、作業療法士、言語聴覚士、管理栄養士、MSW等多職種からの包括的疾病管理プログラムを実践しています</div>
                      </div>
                      <div className="border-b border-white/20 pb-5">
                        <div className="text-lg font-bold mb-2">③循環器センターの協力体制</div>
                        <div className="text-primary-100 text-sm leading-relaxed">内科、外科で協力して患者さんに適した治療を選択し、実践しております</div>
                      </div>
                      <div>
                        <div className="text-lg font-bold mb-2">④心臓リハビリテーション</div>
                        <div className="text-primary-100 text-sm leading-relaxed">入院中から外来、維持期への外来での心臓リハビリテーションが可能です</div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white border-2 border-gray-200 p-8 rounded-3xl">
                    <div className="w-full h-64 rounded-2xl overflow-hidden mb-6">
                      <img
                        src="https://public.readdy.ai/ai/img_res/c8c52d755f1d96630330a52e708da5fd.jpg"
                        alt="Project Network"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">連携ネットワーク</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      地域全体で患者さんを支える医療連携体制を構築しています
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-medical-beige">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">プロジェクトの流れ</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {[
                { step: '01', title: 'スクリーニング', desc: '定期健診での早期発見' },
                { step: '02', title: '精密検査', desc: '専門医による詳細診断' },
                { step: '03', title: '治療計画', desc: '個別最適化された治療' },
                { step: '04', title: '継続管理', desc: '地域連携による支援' },
              ].map((item, index) => (
                <div key={index} className="bg-white p-8 rounded-2xl text-center hover:shadow-lg transition-all">
                  <div className="text-5xl font-black text-primary-200 mb-4">{item.step}</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-gray-600 text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default About;
